"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fibonacci = fibonacci;
exports.map = map;
exports.take = take;
var symbolIterator = Symbol.iterator;

// -------------------------------------------------------------------

var DONE = { done: true };

var makeIterator = function makeIterator(next) {
  var iterator = { next: next };
  iterator[symbolIterator] = function () {
    return iterator;
  };

  return iterator;
};

// -------------------------------------------------------------------

// Returns an iterator to the Fibonacci sequence.
function fibonacci() {
  var curr = 1;
  var next = 1;

  return makeIterator(function () {
    var tmp = curr;

    curr = next;
    next += tmp;

    return {
      done: false,
      value: tmp
    };
  });
}

// Usage: iterable::map(fn) → iterable
function map(fn) {
  var iterator = this[symbolIterator]();
  return makeIterator(function () {
    var item = iterator.next();
    if (item.done) {
      return DONE;
    }

    return {
      done: false,
      value: fn(item.value)
    };
  });
}

// Usage: iterable::take(n) → iterable
function take(n) {
  if (n < 1) {
    return makeIterator(function () {
      return DONE;
    });
  }

  if (n === Infinity) {
    return this;
  }

  var iterator = this[symbolIterator]();
  return makeIterator(function () {
    var item = void 0;
    if (!n-- || (item = iterator.next()).done) {
      return DONE;
    }

    return {
      done: false,
      value: item.value
    };
  });
}

// ===================================================================

exports.default = function () {
  var _context;

  var tries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return (_context = (_context = fibonacci(), map).call(_context, function (x) {
    return Math.round((x + Math.random() - 0.5) * 1e3);
  }), take).call(_context, tries);
};
//# sourceMappingURL=backoff.js.map